import React from "react";

import styles from "./Blockquote.module.scss";

const Blockquote = ({ children }: { children: string }) => {
    return <blockquote className={styles["blockquote"]}>{children}</blockquote>;
};

export default Blockquote;
